
let SugerenciaConfig  = {
   
	MINIMO_CARACTERES: 4,
	TextoBusqueda: null,

	TODOS: 1,
	SUJETO_ACTIVO: 2,
	REPRESENTADO: 3,
	AUDIENCIA: 4,
	SUJETO_PASIVO: 5,
	VIAJE: 6,
	DONATIVO: 7,
	MATERIA: 8,
	DESTINO: 9,
	SINGULARIZACION: 10
}

export default SugerenciaConfig;


// WEBPACK FOOTER //
// ./src/busqueda/config/sugerencia.config.js